export default __webpack_public_path__ + "static/media/Press meet points DASARA-2024 on 24-9-2024.28ad4390.pdf";